import styled from "styled-components";
import { Spinner } from "react-bootstrap";

export const StyledLoader = styled(Spinner)`
   color: brown;
`;
